import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

import classNames from "classnames";

import { Phone } from "./icons";

function CardItem({ title, period, price, month_price, highlight }) {
  const classes = classNames(
    {
      "border-red-500": highlight==="best",
      "border-indigo-500": highlight==="better",
      "border-gray-300": !highlight,
    },
    "h-full",
    "p-6 rounded-lg",
    "border-2",
    "flex",
    "flex-col",
    "relative overflow-hidden"
  );

  const classesBtn = classNames(
    {
      "bg-red-500": highlight==="best",
      "hover:bg-red-600": highlight==="best",
      "bg-indigo-500": highlight==="better",
      "hover:bg-indigo-600": highlight==="better",
      "bg-gray-400": !highlight,
      "hover:bg-gray-500": !highlight
    },
    "flex",
    "items-center",
    "mt-auto",
    "text-white",
    "bg-gray-400",
    "border-0",
    "py-2",
    "px-4",
    "w-full",
    "focus:outline-none",
    "hover:bg-gray-500",
    "rounded"
  );

  return (
    <div class="p-4 xl:w-1/4 md:w-1/2 w-full">
      <div className={classes}>
        {highlight==="best" && (
          <span class="bg-red-500 text-white px-3 py-1 tracking-widest text-xs absolute right-0 top-0 rounded-bl">
            САМАЯ ВЫГОДНАЯ
          </span>
        )}
        {highlight==="better" && (
          <span class="bg-indigo-500 text-white px-3 py-1 tracking-widest text-xs absolute right-0 top-0 rounded-bl">
            ВЫГОДНАЯ
          </span>
        )}
        <h2 class="text-sm tracking-widest title-font uppercase font-medium">
          {title}
        </h2>
        <h2 class="text-sm tracking-widest title-font mb-1 font-medium">
          {period}
        </h2>
        <h1 class="text-5xl text-gray-900 pb-4 mb-4 border-b border-gray-200 leading-none">
          {price}
        </h1>
        <span class="text-lg ml-1 pb-4 mb-4 font-normal text-gray-500">
          стоимость месяца {month_price}
        </span>
        <a className={classesBtn} href="tel:323215">
          Позвонить <span className="ml-auto"><Phone /></span>
        </a>
      </div>
    </div>
  );
}

function Button({ text, active, handler }) {
  const classes = classNames(
    {
      "bg-gray-500 text-white": active
    },
    "py-1",
    "px-4",
    "focus:outline-none"
  );
  return (
    <button onClick={handler} className={classes}>
      {text}
    </button>
  );
}

function CardsRow({ cards }) {
  return (
    <React.Fragment>
      {cards.map(card => {
        return (
        <CardItem
          title={card.title}
          period={card.period}
          price={card.price}
          month_price={card.month_price}
          highlight={card.highlight}
        />
        )
      })}
    </React.Fragment>
  )
}

function Cards() {
  const [active, setActive] = useState({
    unlimited: true,
    daytime: false,
    weekend: false
  });
  const [cardsData, setCardsData] = useState({
    unlimited: [],
    daytime: [],
    weekend: [],
  })

  useEffect(() => {
    setCardsData({
      unlimited: window.whlotos.cards.unlimited,
      daytime: window.whlotos.cards.daytime,
      weekend: window.whlotos.cards.weekend,
    })
  }, [])

  return (
    <React.Fragment>
      <div class="flex">
        <div className="flex border-2 border-gray-500 rounded overflow-hidden h-12 mx-auto lg:mx-0 my-6">
          <Button
            text="Безлимитная"
            active={active.unlimited}
            handler={() =>
              setActive({
                unlimited: true,
                daytime: false,
                weekend: false
              })
            }
          />

          <Button
            text="Дневная"
            active={active.daytime}
            handler={() =>
              setActive({
                unlimited: false,
                daytime: true,
                weekend: false
              })
            }
          />

          <Button
            text="Выходная"
            active={active.weekend}
            handler={() =>
              setActive({
                unlimited: false,
                daytime: false,
                weekend: true
              })
            }
          />
        </div>
      </div>

      {active.unlimited && (
        <div>
          <p class="lg:w-2/3 pb-1 leading-relaxed text-base text-gray-600">
            Посещение клуба без ограничений в часы работы клуба.
          </p>
        </div>
      )}
      {active.daytime && (
        <div>
          <p class="lg:w-2/3 pb-1 leading-relaxed text-base text-gray-600">
            Посещение клуба с 8.00 до 17.00 в рабочие дни, и по выходным с 9.00
            до 21.00.
          </p>
        </div>
      )}
      {active.weekend && (
        <div>
          <p class="lg:w-2/3 pb-1 leading-relaxed text-base text-gray-600">
            Посещение клуба по субботам и воскресеньям в часы работы клуба.
          </p>
        </div>
      )}

      <ul className="pl-2 leading-relaxed text-base text-gray-600">
        <li>😎 Вводный инструктаж</li>
        <li>💪 Тренажёрный зал</li>
        <li>🏃 Кардио-зона</li>
        <li>👯 Групповые программы</li>
        <li>🥵 Инфракрасная сауна</li>
        <li>💦 Чистая питьевая вода</li>
      </ul>

      <div class="flex flex-wrap -mx-4 my-6">
        {active.unlimited && <CardsRow cards={cardsData.unlimited} />}
        {active.daytime && <CardsRow cards={cardsData.daytime} />}
        {active.weekend && <CardsRow cards={cardsData.weekend} />}
      </div>
    </React.Fragment>
  );
}

ReactDOM.render(<Cards />, document.getElementById("react-cards"));
